import ApproximatelyEqualIcon from '@/components/icons/ApproximatelyEqualIcon';
import ArrowDownLeftIcon from '@/components/icons/ArrowDownLeftIcon';
import ArrowUpRightIcon from '@/components/icons/ArrowUpRightIcon';
import CalendarIconSolid from '@/components/icons/CalendarIconSolid';
import ChartBarLineIconSolid from '@/components/icons/ChartBarLineIconSolid';
import DollarCircleIconSolid from '@/components/icons/DollarCircleIconSolid';
import Door_01_IconSolid from '@/components/icons/Door_01_IconSolid';
import DoorIconSolid from '@/components/icons/DoorIconSolid';
import HomeIconSolid from '@/components/icons/HomeIconSolid';
import Settings_01_IconSolid from '@/components/icons/Settings_01_IconSolid';
import User_02_IconSolid from '@/components/icons/User_02_IconSolid';
import { ChartConfig } from '@/components/ui/chart';
import { CalendarEventType } from '@/features/calendar/types/calendar-dto';

const getIndicatorConfig = {
	positive: {
		icon: ArrowUpRightIcon,
		colorClass: 'text-success-1000 stroke-success-1000',
		sign: '+',
	},
	negative: {
		icon: ArrowDownLeftIcon,
		colorClass: 'text-error-1000 stroke-error-1000',
		sign: '',
	},
	equal: {
		icon: ApproximatelyEqualIcon,
		colorClass: 'text-warning-400 stroke-warning-400',
		sign: '',
	},
};

type customChartProps = {
	[key: string]: {
		subColor?: string;
		step: number;
		type: string;
		suffix: string;
		iconColor: string;
	};
} & ChartConfig;

const getChartConfig = {
	['Income']: {
		label: 'main.dashboard.components.chart.income',
		icon: DollarCircleIconSolid,
		color: '#2EB566',
		subColor: '#E4F0E9',
		iconColor: 'fill-success-1000',
		step: 5,
    type: '',
		suffix: '',
	},
	['Occupancy rate']: {
		label: 'main.dashboard.components.chart.occupancyRate',
		icon: ChartBarLineIconSolid,
		color: '#565DCF',
		subColor: '#ECECF8',
		iconColor: 'fill-info-1000',
		step: 20,
    type: '%',
		suffix: '',
	},
	['ADR']: {
		label: 'main.dashboard.components.chart.adr',
		icon: CalendarIconSolid,
		color: '#E6A82A',
		subColor: '#F9F2E3',
		iconColor: 'fill-warning-1000',
		step: 100,
    type: '',
		suffix: '',
	},
} satisfies customChartProps;

const getAllChartsConfig = (chart: 'managedBy' | 'totalApartments' | 'totalOwners') => {
	switch(chart) {
		case 'totalApartments': 
			return {
				icon: Door_01_IconSolid,
				iconClasses: 'fill-error-1000',
				iconBgClasses: 'bg-error-100',
				chartMainColor: 'bg-error-1000',
				chartSecondaryColor: ''
			};
		case 'managedBy': 
			return {
				icon: Settings_01_IconSolid,
				iconClasses: 'fill-info-1000',
				iconBgClasses: 'bg-info-100',
				chartMainColor: '#565DCF',
				chartSecondaryColor: '#AAAAAA'
			};
		case 'totalOwners': 
			return {
				icon: User_02_IconSolid,
				iconClasses: 'fill-success-1000',
				iconBgClasses: 'bg-success-100',
				chartMainColor: 'bg-success-1000',
				chartSecondaryColor: ''
			};
	}
};

const getEventsConfig = (option: CalendarEventType) => {
	switch (option) {
		case CalendarEventType.Reservation:
			return {
				text: 'main.dashboard.components.events.reservation',
				icon: CalendarIconSolid,
				colorClass: 'bg-warning-100 fill-warning-1000',
			};
		case CalendarEventType.Accommodation:
			return {
				text: 'main.dashboard.components.events.accommodation',
				icon: HomeIconSolid,
				colorClass: 'bg-info-100 fill-info-1000',
			};
		case CalendarEventType.HouseUse:
			return {
				text: 'main.dashboard.components.events.houseUse',
				icon: DoorIconSolid,
				colorClass: 'bg-success-100 fill-success-1000',
			};		
	}
};

export const DashboardUtils = {
	getIndicatorConfig,
	getChartConfig,
	getAllChartsConfig,
	getEventsConfig
};
